import { CanComponentDeactivate } from './common/guard/can-deactivate.guard';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { AwsUtil } from './authentication/aws.service';
import { UserLoginService } from './authentication/user-login.service';
import { CognitoUtil, LoggedInCallback } from './authentication/cognito.service';
import { ServiceRegistry } from './service/service-registry.service';
import { DashboardEventService } from './dashboard/dashboard-event.service';
import { SnapshotService } from './snapshot/snapshot.service';
import { AppConfig } from './app.config';
import { ConfirmationService } from 'primeng/api';
import { DOCUMENT } from '@angular/common';

const ONE_MINUTE = 1000 * 60;
const ONE_HOUR = ONE_MINUTE * 60;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, LoggedInCallback, CanComponentDeactivate {

    constructor(public awsUtil: AwsUtil,
        public userService: UserLoginService,
        public cognito: CognitoUtil,
        private serviceRegistry: ServiceRegistry,
        private dashboardEventService: DashboardEventService,
        private snapshotService: SnapshotService,
        private appConfig: AppConfig,
        private router: Router,
        private route: ActivatedRoute,
        private confirmationService: ConfirmationService,
        @Inject(DOCUMENT) private document: any
    ) {
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Promise<boolean> | boolean {
        return false;
    }


    idleTimer: NodeJS.Timeout;
    idleGraceWarningIssued = false;



    idleTimeout = ONE_HOUR * 6;
    idleGraceTime = ONE_MINUTE * 10;

    resetIdleTimer(timeoutToUse?: number) {
        if (this.idleGraceWarningIssued) {
            // Don't reset 
            return;
        }
        if (!timeoutToUse) {
            timeoutToUse = this.idleTimeout;
        }
        // console.log(`-- Resetting Idle Timeout --`);
        clearTimeout(this.idleTimer);
        this.idleTimer = setTimeout(() => {
            // console.log(`-- Idle Time Crossed --`);
            const currentUrl = String(this.document.location.href);
            if (currentUrl.includes('loggedout')) {
                // We are already logged out. No need to continue with timer
                clearTimeout(this.idleTimer);
                return;
            }
            if (this.idleGraceWarningIssued) {
                // console.log(`== Idle Logout ==`);
                this.confirmationService.close();
                clearTimeout(this.idleTimer);
                this.userService.logoutAsync()
                    .then(() => {
                        this.router.navigateByUrl('/loggedout')
                            .then((success: boolean) => {
                                console.log(`Logout: ${success}`);
                            })
                            .catch((err) => {
                                console.log('Logout error:' + err);
                            });
                    });

            } else {
                this.showIdleGracePeriodWarning();
            }
        }, timeoutToUse);
    }

    showIdleGracePeriodWarning() {
        // console.log(`-- Showing Grace Warning --`);
        this.resetIdleTimer(this.idleGraceTime);
        this.idleGraceWarningIssued = true;
        this.confirmationService.confirm({
            message: `You have been idle. You will be logged out in ${this.idleGraceTime / 1000} seconds.`,
            header: `Idle Timeout`,
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: `Keep me logged in!`,
            key: 'idle-confirm',
            accept: () => {
                this.idleGraceWarningIssued = false;
                this.resetIdleTimer();
            },
            closeOnEscape: false,
            rejectVisible: false,
        });
    }



    startIdleMonitor() {
        window.onload = () => { this.resetIdleTimer(); };
        // DOM Events
        document.onmousemove = () => { this.resetIdleTimer(); };
        document.onkeypress = () => { this.resetIdleTimer(); };
        this.resetIdleTimer();
    }

    ngOnInit() {
        const info = this.appConfig.getTenantInfo();
        this.serviceRegistry.setTenantInfo(info);
        this.userService.isAuthenticated(this);
        this.startIdleMonitor();
    }

    // getParameterByName(name: any) {
    //     const url = window.location.href;
    // name = name.replace(/[[]]/g, "\$&");
    // const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    // const results = regex.exec(url);
    // if (!results) {
    //     return null;
    // }
    // if (!results[2]) {
    //     return '';
    // }

    //     return decodeURIComponent(results[2].replace(/+/g, ' '));
    // }

    isLoggedIn(message: string, isLoggedIn: boolean) {
        console.log('AppComponent: the user is authenticated: ' + isLoggedIn);
        if (!isLoggedIn || this.appConfig.getUseJSONData()) {
            this.router.navigate(['/']);
            return;
        }
        const mythis = this;
        this.cognito.getAccessToken()
            .then((token: string) => {
                // Include the passed-in callback here as well so that it's executed downstream
                mythis.awsUtil.initAwsService({
                    callback: () => { },
                    callbackWithParam: (param) => {
                        // mythis.serviceRegistry.startUpServices((allSuccess: boolean) => {

                        // });
                    }
                }, isLoggedIn, token);
            });
        this.cognito.getUserAttributes({
            callback() {

            },
            callbackWithParam(attributes: any) {
                console.log('AppComponent: got the following user attributes:' + JSON.stringify(attributes));
            }
        });
        // this.cognito.getSyncManagerDataSet({
        //     callback() {

        //     },
        //     callbackWithParam(dataset: any) {
        //         console.log("AppComponent: got the following dataset " + dataset);
        //     }
        // });
    }

}
